import React, { useState, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { Container, Row, Col, Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, EffectCoverflow, Pagination, Navigation } from 'swiper/core';
import VideoBlock from '../videoBlock/videoBlock.component';
import DummyTestimonial from '../../assets/images/dummy/Testimonial.png';

import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { bucket_url } from '../../constants/const';
// import "./videoGalleryComponent.css";
// import { videos } from "../../data/videos";

// install Swiper modules
SwiperCore.use([Autoplay, EffectCoverflow, Pagination, Navigation]);

const TestimonialGallery = () => {
    const [allTestimonial, setAllTestimonial] = useState(null)
    const { laoding, testimonials } = useSelector(state => state.all)

    useEffect(() => {
        if (testimonials && testimonials.length > 0) {
            setAllTestimonial(testimonials)
        }
    }, [testimonials])
    // const [currentImage, setCurrentImage] = useState(0);
    // const [viewerIsOpen, setViewerIsOpen] = useState(false);

    // const openLightbox = useCallback((event, { photo, index }) => {
    //     setCurrentImage(index);
    //     setViewerIsOpen(true);
    // }, []);

    // const closeLightbox = () => {
    //     setCurrentImage(0);
    //     setViewerIsOpen(false);
    // };

    return (
        !!allTestimonial &&
        <Swiper
            // effect={'coverflow'}
            slidesPerView={'1'}
            watchSlidesVisibility={true}
            pagination={{
                clickable: true
            }}
            loop={true}
            navigation={{
                enabled: true,
            }}
            autoplay={{
                "delay": 2500,
                "pauseOnMouseEnter": true,
                "disableOnInteraction": false
            }}
            className="testimonial-swiper box-shadow-danger"
            // styleName="video-swiper"
        >
            {
                testimonials.map(testimonial => {
                    return (
                        <SwiperSlide key={`key_${testimonial._id}`}>
                            <div className='testimonial-wrap pb-5 pt-4 pt-md-5 bg-light'>
                                <div className=''>
                                    <Row className='align-items-center'>
                                        <Col xs={12} md={4} className="mb-4 mb-md-0">
                                            <Card className='border-0 bg-transparent'>
                                                <Card.Img className="testimonial-poster" variant="top" src={`${bucket_url}${testimonial.image}`} />
                                            </Card>
                                        </Col>
                                        <Col xs={12} md={8}>
                                            <div className="testimonial-text-wrap">
                                                <p>{testimonial.comment}</p>
                                                <h3 className='name'>{testimonial.name}</h3>
                                                <h6 className='recognition'>{testimonial.recognition}</h6>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                })
            }
            {/* <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide>
            <SwiperSlide>
                <VideoBlock />
            </SwiperSlide> */}
        </Swiper>
    )
}

export default TestimonialGallery;